export const holidayArray = [
  '1/1/2024',
  '1/15/2024',
  '2/12/2024',
  '2/19/2024',
  '3/29/2024',
  '5/27/2024',
  '6/19/2024',
  '7/4/2024',
  '9/2/2024',
  '10/14/2024',
  '11/5/2024',
  '11/11/2024',
  '11/28/2024',
  '12/24/2024',
  '12/25/2024',
  '12/26/2024',
  '12/27/2024',
  '12/30/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
  '12/31/2024',
];
